export enum CampaignSharingType {
    CLIENT = 'client',
    SUPPLIER = 'supplier',
    OWN_MANAGEMENT = 'own_management',
}
